import Image from "next/image";

import Overline from "~/componentsDS/Typography/Overline";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import type { StepItem } from "../index";

type HowItWorksStepCardProps = StepItem & {
    stepNumber: number;
};

const HowItWorksStepCard = ({ imageUrl, imageAlt, icon, title, description, stepNumber }: HowItWorksStepCardProps) => {
    return (
        <div className="flex flex-col w-full h-full rounded-2xl overflow-hidden">
            <div className="relative h-[68vw] sm:h-[350px]">
                <Image
                    src={imageUrl}
                    alt={imageAlt ?? `Step ${stepNumber} illustration`}
                    fill
                    sizes="
                        (max-width: 639px) 100vw,
                        (max-width: 1279px) 500px,
                        33vw
                    "
                    quality={95}
                    className="object-cover object-center"
                />
            </div>
            <div className="flex flex-1 gap-4 px-3 py-8 md:px-4 md:py-6 bg-gray100">
                <div className="shrink-0">
                    {icon}
                </div>
                <div className="flex flex-col flex-1">
                    <Overline weight="500" className="text-[12px] md:text-[15px] tracking-[0.96px] md:tracking-[1.21px] text-primary300 mb-3 md:mb-4">Step {stepNumber}</Overline>
                    <Heading as="h3" className="text-[18px] md:text-[24px] font-medium text-primary500 leading-[1.1] mb-1">{title}</Heading>
                    <Paragraph size="md" sizes={{md: "lg"}} className="text-primary500">{description}</Paragraph>
                </div>
            </div>
        </div>
    )
};

export default HowItWorksStepCard;
